var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("DropdownFilter", {
    attrs: {
      value: _vm.chosenProjects,
      options: _vm.projects,
      placeholder: _vm.placeholderText,
      loading: _vm.$apollo.queries.projects.loading,
      processing: _vm.processing,
      multiple: !_vm.single,
      invalid: _vm.invalid,
      max: _vm.max,
      withoutLoading: _vm.withoutLoading,
      customMultiStyleParent: _vm.getcontainerStyle,
      trackBy: "id",
    },
    on: {
      search: (v) => (_vm.projectSearchString = v),
      input: _vm.handleInput,
    },
    scopedSlots: _vm._u([
      {
        key: "option",
        fn: function ({ option }) {
          return [_c("ProjectMultiselectOption", { attrs: { option: option } })]
        },
      },
      {
        key: "tag",
        fn: function ({ option, remove }) {
          return [
            _c("MultiselectTag", {
              attrs: { remove: remove, option: option },
              on: { remove: remove },
              scopedSlots: _vm._u(
                [
                  {
                    key: "name",
                    fn: function () {
                      return [
                        _c("ProjectMultiselectOption", {
                          staticClass: "w-full pl-1",
                          attrs: {
                            option: option,
                            selectedInline: _vm.selectedInline,
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                true
              ),
            }),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }